import React from 'react';
import Oracion from './Oracion';

const Parrafo = ({ 
    data, 
    verTraduccion, 
    verDesglose, 
    verFurigana,
    verRomaji,    
    handleClickSegmento, 
    indice,
    destacado
}) => {

    const imageUrl = data.image ? `${process.env.REACT_APP_BACKEND_URL}/api/cuentos/ilustraciones/${data.image}`
        : null;

    return (
        <>
            <div className="p-4 w-full md:w-1/2 mx-auto">
                {imageUrl && (
                    <div className="rounded-lg border-2 border-gray-300 shadow-lg p-4 bg-white">
                        <img src={imageUrl} alt="imagen párrafo" className="rounded w-full object-cover" />
                    </div>
                )}
            </div>

            <div className="w-full my-10">
                {data.sentences.map((sentence, indexSentence) => (
                    <React.Fragment key={`oracion_fragment_${indexSentence}`}>
                        <Oracion 
                            data={sentence} 
                            verTraduccion={verTraduccion}
                            verDesglose={verDesglose}
                            verFurigana={verFurigana}
                            verRomaji={verRomaji}
                            handleClickSegmento={handleClickSegmento}
                            indice={`${indice}_${indexSentence}`}
                            destacado={destacado}
                        />
                        {verTraduccion && (
                            <p className="text-2xl font-semibold text-gray-800 mb-8 text-center italic">
                                {sentence.es}
                            </p>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </>
    );
};

export default Parrafo;